var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-tabs"},[_c('button',{staticClass:"login-tab",class:{ 'is-active': _vm.loginType == 'account' },on:{"click":_vm.onAccountClick}},[_vm._v(" 账号密码登录 ")]),_c('button',{staticClass:"login-tab",class:{ 'is-active': _vm.loginType == 'phone' },on:{"click":_vm.onPhoneClick}},[_vm._v(" 手机验证登录 ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }